import { render, staticRenderFns } from "./ModelListSelectbox.vue?vue&type=template&id=35671c9e"
import script from "./ModelListSelectbox.vue?vue&type=script&lang=js"
export * from "./ModelListSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports